module.exports = __webpack_public_path__ + "media/components/assets/icons/label_vod-9d0141d0d62f9a350b243776eca34ecf.svg";